import {
  CustomGroupSectionAttributes,
  CustomSectionContentState,
  CustomSectionState,
} from 'api/custom-section/types';
import { CustomGroupSectionType } from 'api/custom-section/types/group-section';

export const defaultGroupSectionConfig: Record<
  CustomGroupSectionType,
  CustomGroupSectionAttributes
> = {
  [CustomGroupSectionType.CustomHeadingSection]: {
    title: '',
    config: {
      description: '',
    },
    contentState: CustomSectionContentState.Prompt,
    sectionType: CustomGroupSectionType.CustomHeadingSection,
    state: CustomSectionState.Open,
  },
  [CustomGroupSectionType.MultiQuestions]: {
    title: '',
    config: {
      description: '',
    },
    contentState: CustomSectionContentState.Prompt,
    sectionType: CustomGroupSectionType.MultiQuestions,
    state: CustomSectionState.Open,
  },
};
